export default {
    init() {
        // JavaScript to be fired on the about us page
        jQuery('section.job-vacancies a.btn[data-job]').on('click', (e) => {
            e.preventDefault();
            const job = jQuery(e.currentTarget).data('job');
            jQuery('.cc_form select[name=position]').val(job);
            jQuery('html, body').animate({
                scrollTop: jQuery('.cc_form').offset().top - 100,
            }, 1000);
        });
    },
};



// WEBPACK FOOTER //
// ./scripts/routes/Careers.js